var _circle, _path, _path2, _path3, _g, _path4, _rect, _rect2, _rect3, _circle2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoData = function SvgNoData(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#BFBFBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 70H87.5V79C87.5 82.3137 84.8137 85 81.5 85H39.5C36.1863 85 33.5 82.3137 33.5 79V70Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 70H69.5V73C69.5 74.6569 68.1569 76 66.5 76H54.5C52.8431 76 51.5 74.6569 51.5 73V70Z",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20791_111401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 50,
    width: 55,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 70H87.5L77.6398 52.0723C76.9368 50.7941 75.5937 50 74.1349 50H46.8651C45.4063 50 44.0632 50.7941 43.3602 52.0723L33.5 70Z",
    fill: "#E2E2E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20791_111401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 70H87.5L76.5 50H44.5L33.5 70Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 50,
    width: 32,
    height: 10,
    fill: "#ACACAC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 70H79.5L76.5 60H44.5L41.5 70Z",
    fill: "#969696"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 31,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#969696"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.2705,
    y: 32.9609,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(20 74.2705 32.9609)",
    fill: "#969696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6201,
    y: 33.6055,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-20 44.6201 33.6055)",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20791_111401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#6B0707"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20791_111401)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-data.d6ba057555761163f404b95d7fcb8c95.svg";